module.exports = __webpack_public_path__ + "static/media/LoginPage.65a549c9.png";